const handbagJson = 

[
  {
    "favourite": false,
    "year": "2025",
    "handbagId": "thequeenelizabethpub25",
    "name": "The Queen Elizabeth Pub",
    "inLookbook": true,
    "imageUrl": "",
    "season": "SS25",

    "variations": {
      "theme": [],
      "size": [],
      "version": null,
      "color": [],
      "design": [
        {
          "name": "The Queen Elizabeth Pub Box Bag",
          "designId": "thequeenelizabethpubboxbag25",
          "shape": "Box Bag",
          "measurements": "21cm (H) x 25cm (W) x 9cm (D)",
          "favourite": false,
          "price": 150,
          "categories": [
            "Handbag"
          ],
          "productInfo": "Original Box shape, Detachable and adjustable vegan leather shoulder strap, 3 ways wear; backpack, crossbody or handbag, 1 main compartment, 1 inside zipped pocket & 1 open zipped pocket, 1 external zipped pocket",
          "imageUrls": [
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/v/e/vendula_queenelizabethpub_march25_sj_selectshq-40.jpg"
          ]
        },
        {
          "name": "The Queen Elizabeth Pub Classic Backpack",
          "designId": "thequeenelizabethpubclassicbackpack25",
          "shape": "Classic Backpack",
          "measurements": "24cm (H) x 32cm (W) x 10cm (D)",
          "favourite": false,
          "price": 135,
          "categories": [
            "Backpack"
          ],
          "productInfo": "1 main compartment with zip closure, 1 inside zipped pocket, 2 inside open pockets, Detachable and adjustable shoulder straps, Comfortable handle",
          "imageUrls": [
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/v/e/vendula_queenelizabethpub_march25_sj_selectshq-59.jpg"
          ]
        },
        {
          "name": "The Queen Elizabeth Pub Cora Bag",
          "designId": "thequeenelizabethpubcorabag25",
          "shape": "Cora",
          "measurements": "20cm (H) x 26cm (W) x 14cm (D)",
          "favourite": false,
          "price": 195,
          "categories": [
            "Handbag"
          ],
          "productInfo": "Comfortable handle, Detachable and adjustable vegan leather shoulder straps, 3 ways wear; backpack, crossbody or handbag, 1 main compartment, 1 inside zipped pocket & 1 open zipped pocket, 1 external zipped pocket",
          "imageUrls": [
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/v/e/vendula_queenelizabethpub_march25_sj_selectshq-50.jpg"
          ]
        },
        {
          "name": "The Queen Elizabeth Pub Double Zipper Coin Purse",
          "designId": "thequeenelizabethpubdoublezippercoinpurse25",
          "shape": "Zipper Coin Purse",
          "measurements": "10cm (H) x 15cm (W) x 1cm (D)",
          "favourite": false,
          "price": 55,
          "categories": [
            "Purse"
          ],
          "productInfo": "1 main compartment with zip closure, 3 card slots, Attached keychain",
          "imageUrls": [
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/d/s/dsc_0227_2.png"
          ]
        },
        {
          "name": "The Queen Elizabeth Pub Luna Pouch",
          "designId": "thequeenelizabethpublunapouch25",
          "shape": "Luna",
          "measurements": "19cm (H) x 27cm (W) x 9cm (D)",
          "favourite": false,
          "price": 105,
          "categories": [
            "Accessory"
          ],
          "productInfo": "Detachable and adjustable vegan leather shoulder strap, 1 main compartment with zip closure, 1 external back zipped pocket, 1 inside zipped pocket, 1 inside open pocket",
          "imageUrls": [
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/v/e/vendula_queenelizabethpub_march25_sj_selectshq-127.jpg"
          ]
        },
        {
          "name": "The Queen Elizabeth Pub Universal Flip Phone Case",
          "designId": "thequeenelizabethpubuniversalflipphonecase25",
          "shape": "Universal Flip Phone Case",
          "measurements": "17.8cm (H) x 9.2cm (W) x 2.8cm (D)",
          "favourite": false,
          "price": 40,
          "categories": [
            "Accessory",
            "Phone Case"
          ],
          "productInfo": "Magnetic snap closure, 3 card slots, one with window for ID, Slip pocket for notes/documents, Sliding track so phone camera can be used without removing phone from case, Expandable grip holds phone in case securely.",
          "imageUrls": [
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/d/s/dsc_0240_2.png"
          ]
        },
        {
          "name": "The Queen Elizabeth Pub Wide Shoulder Strap",
          "designId": "thequeenelizabethpubwideshoulderstrap25",
          "shape": "Wide Shoulder Strap",
          "measurements": "4.5cm (H) x 128cm (W) x 0.4cm (D)",
          "favourite": false,
          "price": 50,
          "categories": [
            "Accessory",
            "Strap"
          ],
          "productInfo": "Printed and embossed vegan leather Hand stitched details in vegan leather. Can be used with any bag that has a removable strap or handle!",
          "imageUrls": [
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/d/s/dsc_0275_2.png"
          ]
        },
        {
          "name": "The Queen Elizabeth Pub Key Charm",
          "designId": "thequeenelizabethpubkeycharm25",
          "shape": "Key Charm",
          "measurements": "9.5cm (H) x 9.5cm (W) x 0.5cm (D)",
          "favourite": false,
          "price": 20,
          "categories": [
            "Accessory",
            "Charm"
          ],
          "productInfo": "Branded dog-clip, Branded split ring",
          "imageUrls": [
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/d/s/dsc_0259_1.png"
          ]
        }
      ]
    }
  },
   {
    "favourite": false,
    "year": "2025",
    "range": "Boutique",
    "pin": "",
    "handbagId": "vendulaheritagevictoriantearooms25",
    "description": "",
    "series": "Heritage",
    "video": "",
    "name": "Vendula Heritage - Victorian Tea Rooms",
    "inLookbook": true,
    "categories": [],
    "imageUrl": "https://i.pinimg.com/736x/62/79/02/627902cd66c0743bab59007bccadc8be.jpg",
    "season": "SS25",
    "edition": "Victorian Tea Rooms",
    "variations": {
      "theme": [],
      "size": [],
      "version": null,
      "color": [],
      "design": [
        {
          "name": "Vendula Heritage - Victorian Tea Rooms Sienna Bag",
          "designId": "vendulaheritagevictoriantearoomssiennabag25",
          "shape": "Sienna",
          "measurements": "24cm (H) x 30cm (W) x 11cm (D)",
          "favourite": false,
          "price": 110,
          "categories": [
            "Handbag",
            "Crossbody"
          ],
          "productInfo": "Comfortable handle, 2 compartments, 2 inside zipped pockets, 1 inside open pocket, 1 external zipped pocket",
          "imageUrls": [
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/i/m/image00039.jpg"
          ]
        },

        {
          "name": "Vendula Heritage - Victorian Tea Rooms Cassie Bag",
          "designId": "vendulaheritagevictoriantearoomscassiebag25",
          "shape": "Cassie",
          "measurements": "15.5cm (H) x 23.5cm (W) x 7cm (D)",
          "favourite": false,
          "price": 115,
          "categories": [
            "Handbag"
          ],
          "productInfo": "1 main compartment with zip closure, 1 inside open pocket, Comfortable handle, Detachable shoulder strap",
          "imageUrls": [
            "https://thumbs.nosto.com/quick/magento-98745272/8/3931/2718f9d3ff1d4bc03a3a110ab797973e856b2d6698bf3d10b63f623063a47494/A"
          ]
        },
        {
          "name": "Vendula Heritage - Victorian Tea Rooms Bonnie Weekender",
          "designId": "vendulaheritagevictoriantearoomsbonnieweekender25",
          "shape": "Bonnie Weekender",
          "measurements": "30cm (H) x 50cm (W) x 15cm (D)",
          "favourite": false,
          "price": 105,
           "categories": [
            "Tote",
            "Handbag",
            "Crossbody"
          ],
          "productInfo": "2 carry handles, Detachable and adjustable shoulder strap, 1 main compartment with zip closure, 1 inside zipped pocket, 2 inside open pockets, 1 external zipped pocket",
          "imageUrls": [
            "https://thumbs.nosto.com/quick/magento-98745272/8/3930/2031715d9112774785d7cf65515d73fb7226aac69da35d088966f099d961baf2/A"
          ]
        },

             {
          "name": "Vendula Heritage - Victorian Tea Rooms Ornate Handle Bubble Bag",
          "designId": "vendulaheritagevictoriantearoomssmallornatehandlebag25",
          "shape": "Ornate Handle Bubble Bag",
          "measurements": "16cm x 26cm x 8cm",
          "favourite": false,
          "price": 65,
           "categories": [
            "Handbag",
            "Crossbody"
          ],
          "productInfo": "Printed and embossed vegan leather, Hand stitched details 2 carry handles, Fully lined with exclusive cotton lining",
          "imageUrls": [
            "https://www.lovepersimmon.com.au/cdn/shop/files/k96173331_vendula_heritage_-_victorian_tea_rooms_ornate_handle_bubble_bag_front.jpg",
            "https://www.lovepersimmon.com.au/cdn/shop/files/image00048_1.jpg",
            "https://www.lovepersimmon.com.au/cdn/shop/files/image00041.jpg",
            "https://www.lovepersimmon.com.au/cdn/shop/files/image00045_1.jpg",
            "https://www.lovepersimmon.com.au/cdn/shop/files/dsc_0437.png",
            "https://www.lovepersimmon.com.au/cdn/shop/files/dsc_0404_1.png",
            "https://www.lovepersimmon.com.au/cdn/shop/files/k96173331_vendula_heritage_-_victorian_tea_rooms_ornate_handle_bubble_bag_1.jpg",
            "https://www.lovepersimmon.com.au/cdn/shop/files/k96173331_vendula_heritage_-_victorian_tea_rooms_ornate_handle_bubble_bag_back.jpg",
            "https://www.lovepersimmon.com.au/cdn/shop/files/k96173331_vendula_heritage_-_victorian_tea_rooms_ornate_handle_bubble_bag_3.jpg"
          ]
        },

         {
          "name": "Vendula Heritage - Victorian Tea Rooms Kitty Teapot",
          "designId": "vendulaheritagevictoriantearoomskittyteapot25",
          "shape": "Kitty Teapot",
          "measurements": "24cm (H) x 22cm (W) x 15cm (D)",
          "favourite": false,
          "price": 95,
            "categories": [
            "Crossbody",
            "Satchel",
            "Handbag",
            "Shoulder"
          ],
          "productInfo": "Printed and embossed vegan leather, Hand stitched details, Detachable and adjustable vegan leather shoulder strap, 1 main compartment with zip closure, Fully lined with exclusive cotton lining",
          "imageUrls": [
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/k16163331_vendula_heritage_-_victorian_tea_rooms_kitty_teapot_front-100x100.jpg",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/dsc_0370_1-100x100.png",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/dsc_0380_3-100x100.png",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/dsc_0385-100x100.png",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/dsc_0397_2-100x100.png",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/image00006_5-100x100.jpg",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/image00029-100x100.jpg",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/image00031-100x100.jpg",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/image00032-100x100.jpg",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/image00033_1-100x100.jpg",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/k16163331_vendula_heritage_-_victorian_tea_rooms_kitty_teapot_0-100x100.jpg",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/k16163331_vendula_heritage_-_victorian_tea_rooms_kitty_teapot_1-100x100.jpg",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/k16163331_vendula_heritage_-_victorian_tea_rooms_kitty_teapot_2-1-100x100.jpg",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/k16163331_vendula_heritage_-_victorian_tea_rooms_kitty_teapot_back-100x100.jpg",
            "https://lovelyboutique.co.uk/wp-content/uploads/2025/04/k16163331_vendula_heritage_-_victorian_tea_rooms_kitty_teapot_3-100x100.jpg"
          ]
        },

             {
          "name": "Vendula Heritage - Victorian Tea Rooms Universal Flip Phone Case",
          "designId": "vendulaheritagevictoriantearoomsuniversalflipphonecase25",
          "shape": "Universal Flip Phone Case",
          "measurements": "17.8cm (H) x 9.2cm (W) x 2.8cm (D)",
          "favourite": false,
          "price": 35,
            "categories": [
            "Accessory",
            "Phone Case"
          ],
          "productInfo": "Magnetic snap closure, 3 card slots, one with window for ID, Slip pocket for notes/documents, Sliding track so phone camera can be used without removing phone from case, Expandable grip holds phone in case securely.",
          "imageUrls": [
           "https://thumbs.nosto.com/quick/magento-98745272/8/3875/ec7d09bd695e378c6c1370482b6393415d4b8d93e7616de8a496be9f106a9dfd/A"
          ]
        },

           {
          "name": "Vendula Heritage - Victorian Tea Rooms Key Charm",
          "designId": "vendulaheritagevictoriantearoomskeycharm25",
          "shape": "Key Charm",
          "measurements": "9.5cm (H) x 9.5cm (W) x 0.5cm (D)",
          "favourite": false,
          "price": 20,
            "categories": [
            "Accessory",
            "Charm"
          ],
          "productInfo": "Branded dog-clip, Branded split ring",
          "imageUrls": [
            "https://thumbs.nosto.com/quick/magento-98745272/8/3933/d20623e4db00de406fc6a09fc3d18855ad2ebf4a07ab4fdf367e2f28e900a97a/A"
          ]
        },

        {
          "name": "Vendula Heritage - Victorian Tea Rooms Kate Bag",
          "designId": "vendulaheritagevictoriantearoomskatebag25",
          "shape": "Kate Bag",
          "measurements": "16.5cm (H) x 26cm (W) x 1.5cm (D)",
          "favourite": false,
          "price": 65,
            "categories": [
            "Handbag"
          ],
          "productInfo": "1 main compartment with zip closure, 1 inside open pocket, 1 external zipped pocket",
          "imageUrls": [
             "https://thumbs.nosto.com/quick/magento-98745272/8/3932/19520280207c6faa8102c45d38ae3b54aacb8c364e7f9e6fdb2eee6c9d61faac/A"
          ]
        },


        {
          "name": "Vendula Heritage - Victorian Tea Rooms Wide Shoulder Strap",
          "designId": "vendulaheritagevictoriantearoomswideshoulderstrap25",
          "shape": "Wide Shoulder Strap",
          "measurements": "4.5cm (H) x 128cm (W) x 0.4cm (D)",
          "favourite": false,
          "price": 40,
           "categories": [
            "Accessory",
            "Strap"
          ],
          "productInfo": "Printed and embossed vegan leather Hand stitched details in vegan leather. Can be used with any bag that has a removable strap or handle!",
          "imageUrls": [
              "https://thumbs.nosto.com/quick/magento-98745272/8/3876/089ceeb799772c9bf694f41e2f9a48b21ec682f27f035335d30629a4d71722d3/A"
          ]
        },



        {
          "name": "Vendula Heritage - Victorian Tea Rooms Amelia Backpack",
          "designId": "vendulaheritagevictoriantearoomsameliabag25",
          "shape": "Amelia Backpack",
          "measurements": "20cm (H) x 22cm (W) x 9cm (D)",
          "favourite": false,
          "price": 90,
            "categories": [
            "Backpack",
            "Handbag"
          ],
          "productInfo": "Comfortable handle, Adjustable shoulder straps, 1 main compartment, 1 inside zipped pocket, 1 inside open pocket",
          "imageUrls": [
              "https://rockamilly.com/cdn/shop/files/k86143331_vendula_heritage_-_victorian_tea_rooms_amelia_backpack_front.jpg",
            "https://rockamilly.com/cdn/shop/files/k86143331_vendula_heritage_-_victorian_tea_rooms_amelia_backpack_1.jpg",
            "https://rockamilly.com/cdn/shop/files/k86143331_vendula_heritage_-_victorian_tea_rooms_amelia_backpack_back.jpg",
            "https://rockamilly.com/cdn/shop/files/k86143331_vendula_heritage_-_victorian_tea_rooms_amelia_backpack_3.jpg",
            "https://rockamilly.com/cdn/shop/files/k86143331_vendula_heritage_-_victorian_tea_rooms_amelia_backpack_2.jpg",
            "https://rockamilly.com/cdn/shop/files/dsc_0464.png",
            "https://rockamilly.com/cdn/shop/files/image00007_2_2.jpg",
            "https://rockamilly.com/cdn/shop/files/image00016_4.jpg",
            "https://rockamilly.com/cdn/shop/files/image00017_3_1.jpg",
            "https://rockamilly.com/cdn/shop/files/image00022_2.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/k/8/k86143331_vendula_heritage_-_victorian_tea_rooms_amelia_backpack_1.jpg"
          ]
        },
  
        {
          "name": "Vendula Heritage - Victorian Tea Rooms Shaped Coin Purse",
          "designId": "vendulaheritagevictoriantearoomsshapedcoinpurse25",
          "shape": "Shaped Coin Purse",
          "measurements": "10.5cm (H) x 10cm (W) x 1cm (D)",
          "favourite": false,
          "price": 30,
          "categories": [
            "Purse"
          ],
          "productInfo": "Printed and embossed vegan leather, 1 main compartment with zip closure, 3 card slots",
          "imageUrls": [
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/d/s/dsc_0548_2.png"
          ]
        }
      ]
    }
  },

   {
    "favourite": false,
    "year": "2024",
    "range": "Shopfront",
    "pin": "",
    "handbagId": "ticktockclockshop24",
    "description": "",
    "series": "",
    "video": "",
    "name": "Tick Tock Clock Shop",
    "inLookbook": true,
    "categories": [],
    "imageUrl": "",
    "season": "AW24",
    "edition": "",
    "variations": {
      "theme": [],
      "size": [],
      "version": null,
      "color": [],
      "design": [
        {
          "name": "Tick Tock Clock Shop Phone Pouch",
          "designId": "ticktockclockshopphonepouch24",
          "shape": "Phone Pouch",
          "measurements": "19cm (H) 12.5cm (W) 3cm (D)",
          "favourite": false,
          "price": 55,
          "categories": [
            "Handbag",
            "Crossbody"
          ],
          "productInfo": "Secure zip closing, Easy access magnetic fastener, Flat detachable shoulder strap, Front slip pocket, 2 internal compartments, Back zip pocket with metal look plastic zip and nylon zip puller",
          "imageUrls": [
            "https://thumbs.nosto.com/quick/magento-98745272/8/3749/18792bba6f06b5716bd9a65e4a5bedad9a7e3881d8f6784565c514bbe7865989/A"
          ]
        },

        {
          "name": "Tick Tock Clock Shop Grab Bag",
          "designId": "ticktockclockshopgrabbag24",
          "shape": "Grab Bag",
          "measurements": "23cm (H) x 26cm (W) x 10cm (D)",
          "favourite": false,
          "price": 140,
          "categories": [
            "Handbag"
          ],
          "productInfo": "Comfortable handle, Detachable and adjustable vegan leather shoulder strap, 1 main compartment, 1 inside zipped pocket, 2 inside open pockets, 1 external zipped pocket",
          "imageUrls": [
              "https://thumbs.nosto.com/quick/magento-98745272/8/3743/8e6abd294cb0264cec0786f1b356a9c8b1269e09a06055435c634e6041975f37/A",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_1.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_2.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_3.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_0.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-41.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-43.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-46.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-139.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_front.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-137.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_front_1.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_opening_door.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_back.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_1.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_2.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_3.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_0.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-41.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-43.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-46.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-139.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_front.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-137.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_front_1.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_opening_door.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_back.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/k/1/k10883191_tick_tock_clock_shop_grab_bag_1.jpg"
          ]
        },
        {
          "name": "Tick Tock Clock Shop Carriage Clock Bag",
          "designId": "ticktockclockshopcarriageclockbag24",
          "shape": "Carriage Clock Bag",
          "measurements": "22cm (H) x 17.5cm (W) x 9cm (D)",
          "favourite": false,
          "price": 120,
           "categories": [
            "Handbag",
            "Crossbody"
          ],
          "productInfo": "Printed and embossed vegan leather, Antique gold closing clasp, Antique gold hardware, Comfortable handle, Detachable and adjustable vegan leather shoulder strap, 1 main compartment, 1 inside open pocket, Fully lined with iconic Vendula London lining",
          "imageUrls": [
            "https://thumbs.nosto.com/quick/magento-98745272/8/3741/9c1caf875c873d660ef2c264211f3e60d2f1d9a517b5daf98a4a6f9206026b5b/A",
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/k/1/k16053191_tick_tock_clock_shop_carriage_clock_bag_front.jpg"
          ]
        },

             {
          "name": "Tick Tock Clock Shop Bella Bag",
          "designId": "ticktockclockshopbellabag24",
          "shape": "Bella Bag",
          "measurements": "22cm (H) x 29cm (W) x 4.5cm (D)",
          "favourite": false,
          "price": 100,
           "categories": [
            "Handbag",
            "Crossbody"
          ],
          "productInfo": "Adjustable vegan leather shoulder strap, 2 compartments, 3 ways to wear; Backpack, handbag or crossbody, 1 inside zipped pocket & 2 open pockets, 1 external zipped pocket",
          "imageUrls": [
           "https://vintage-vogue.shop/wp-content/uploads/2024/09/Vendula-London-Tasche-Umhaengetasche-Damen-Tick-Tock-Clock-Shop-Bella-Bag-in-Rot-Weinrot-Vintage-Tasche-1.jpg"
          ]
        },

         {
          "name": "Tick Tock Clock Shop Square Wallet",
          "designId": "ticktockclockshopsquarewallet24",
          "shape": "Square Wallet",
          "measurements": "10cm (H) x 10cm (W) x 2cm (D)",
          "favourite": false,
          "price": 38,
           "categories": [
            "Wallet"
          ],
          "productInfo": "1 compartment for coins, 6 slots for cards, 1 section for notes, Secure zip around fastening",
          "imageUrls": [
               "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/3/f32683191_tick_tock_clock_shop_square_wallet_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/3/f32683191_tick_tock_clock_shop_square_wallet_back.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/3/f32683191_tick_tock_clock_shop_square_wallet_2.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-181.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/3/f32683191_tick_tock_clock_shop_square_wallet_front.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/3/f32683191_tick_tock_clock_shop_square_wallet_front_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-182.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/3/f32683191_tick_tock_clock_shop_square_wallet_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/3/f32683191_tick_tock_clock_shop_square_wallet_back.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/3/f32683191_tick_tock_clock_shop_square_wallet_2.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-181.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/3/f32683191_tick_tock_clock_shop_square_wallet_front.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/3/f32683191_tick_tock_clock_shop_square_wallet_front_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-182.jpg"
          ]
        },

             {
          "name": "Tick Tock Clock Shop Large Ziparound Wallet",
          "designId": "ticktockclockshoplargeziparoundwallet24",
          "shape": "Large Ziparound Wallet",
          "measurements": "10cm (H) x 19.5cm (W) x 2.5cm (D)",
          "favourite": false,
          "price": 48,
            "categories": [
            "Accessory",
            "Wallet"
          ],
          "productInfo": "1 inside zipped coin pocket, 8 card slots, 2 sections for notes, Secure zip around fastening",
          "imageUrls": [
                "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/5/f58483191_tick_tock_clock_shop_large_ziparound_wallet_1_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/5/f58483191_tick_tock_clock_shop_large_ziparound_wallet_2_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/5/f58483191_tick_tock_clock_shop_large_ziparound_wallet_back_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-191.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-236.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/5/f58483191_tick_tock_clock_shop_large_ziparound_wallet_front_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/5/f58483191_tick_tock_clock_shop_large_ziparound_wallet_front_1_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-230.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/5/f58483191_tick_tock_clock_shop_large_ziparound_wallet_1_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/5/f58483191_tick_tock_clock_shop_large_ziparound_wallet_2_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/5/f58483191_tick_tock_clock_shop_large_ziparound_wallet_back_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-191.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/v/e/vendula_nyc_ticktockshop_june24_sj_hq-236.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/5/f58483191_tick_tock_clock_shop_large_ziparound_wallet_front_1.jpg",
      "https://www.vendulalondon.com/media/catalog/product/cache/7b52cf7450e5a91e63fd454fbd0b0ef6/f/5/f58483191_tick_tock_clock_shop_large_ziparound_wallet_front_1_1.jpg"
          ]
        },

           {
          "name": "Tick Tock Clock Shop Key Charm",
          "designId": "ticktockclockshopkeycharm24",
          "shape": "Key Charm",
          "measurements": "9.5cm (H) x 9.5cm (W) x 0.5cm (D)",
          "favourite": false,
          "price": 20,
            "categories": [
            "Accessory",
            "Charm"
          ],
          "productInfo": "Branded dog-clip, Branded split ring",
          "imageUrls": [
             "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/c/2/c23143191_tick_tock_clock_shop_key_charm_front.jpg"
          ]
        },

        {
          "name": "Tick Tock Clock Shop Pocket Watch Bag",
          "designId": "ticktockclockshoppocketwatchbag24",
          "shape": "Pocket Watch Bag",
          "measurements": "16cm (H) x 16cm (W) x 5cm (D)",
          "favourite": false,
          "price": 95,
            "categories": [
            "Handbag"
          ],
          "productInfo": "Hardcase clutch, Rhinestone-encrusted round handle, 1 main compartment featuring card slots, Detachable longer strap with chain detail, Can be worn crossbody, The clock on this bag works with an AA battery (not included!)Once the protective plastic has been removed from the clock, it is no longer returnable",
          "imageUrls": [
             "https://rockamilly.com/cdn/shop/files/tick-tock-clock-shop-pocket-watch-bag-rockamilly-bags-purses-vendula-679916.jpg?v=1725652644&width=1646"
          ]
        },


        {
          "name": "Tick Tock Clock Shop Wide Shoulder Strap",
          "designId": "ticktockclockshopwideshoulderstrap24",
          "shape": "Wide Shoulder Strap",
          "measurements": "4.5cm (H) x 128cm (W) x 0.4cm (D)",
          "favourite": false,
          "price": 45,
           "categories": [
            "Accessory",
            "Strap"
          ],
          "productInfo": "Printed and embossed vegan leather Hand stitched details in vegan leather. Can be used with any bag that has a removable strap or handle!",
          "imageUrls": [
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/c/5/c53183191_tick_tock_clock_shop_wide_shoulder_strap_2.jpg"
          ]
        },



        {
          "name": "Vendula Heritage - Victorian Tea Rooms Amelia Backpack",
          "designId": "vendulaheritagevictoriantearoomsameliabag25",
          "shape": "Amelia Backpack",
          "measurements": "20cm (H) x 22cm (W) x 9cm (D)",
          "favourite": false,
          "price": 90,
            "categories": [
            "Backpack",
            "Handbag"
          ],
          "productInfo": "Comfortable handle, Adjustable shoulder straps, 1 main compartment, 1 inside zipped pocket, 1 inside open pocket",
          "imageUrls": [
              "https://rockamilly.com/cdn/shop/files/k86143331_vendula_heritage_-_victorian_tea_rooms_amelia_backpack_front.jpg",
            "https://rockamilly.com/cdn/shop/files/k86143331_vendula_heritage_-_victorian_tea_rooms_amelia_backpack_1.jpg",
            "https://rockamilly.com/cdn/shop/files/k86143331_vendula_heritage_-_victorian_tea_rooms_amelia_backpack_back.jpg",
            "https://rockamilly.com/cdn/shop/files/k86143331_vendula_heritage_-_victorian_tea_rooms_amelia_backpack_3.jpg",
            "https://rockamilly.com/cdn/shop/files/k86143331_vendula_heritage_-_victorian_tea_rooms_amelia_backpack_2.jpg",
            "https://rockamilly.com/cdn/shop/files/dsc_0464.png",
            "https://rockamilly.com/cdn/shop/files/image00007_2_2.jpg",
            "https://rockamilly.com/cdn/shop/files/image00016_4.jpg",
            "https://rockamilly.com/cdn/shop/files/image00017_3_1.jpg",
            "https://rockamilly.com/cdn/shop/files/image00022_2.jpg",
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/k/8/k86143331_vendula_heritage_-_victorian_tea_rooms_amelia_backpack_1.jpg"
          ]
        },
  
        {
          "name": "Vendula Heritage - Victorian Tea Rooms Shaped Coin Purse",
          "designId": "vendulaheritagevictoriantearoomsshapedcoinpurse25",
          "shape": "Shaped Coin Purse",
          "measurements": "10.5cm (H) x 10cm (W) x 1cm (D)",
          "favourite": false,
          "price": 30,
          "categories": [
            "Purse"
          ],
          "productInfo": "Printed and embossed vegan leather, 1 main compartment with zip closure, 3 card slots",
          "imageUrls": [
            "https://www.vendulalondon.com/media/catalog/product/cache/359604771e0fd1730ccffcd509b79cd0/d/s/dsc_0548_2.png"
          ]
        }
      ]
    }
  }
]


export default handbagJson;
